/* ==========================================================================
   PREMIUM PRODUCT GRID  —  product-grid.js
   ========================================================================== */
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'pg__toast'; t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () { t.classList.remove('is-visible'); setTimeout(function () { t.remove(); }, 250); }, 2000);
  }

  function refreshCartCount() {
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count], .cart-count')
          .forEach(function (el) { el.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: c } }));
      }).catch(function () {});
  }

  function initSection(section) {
    if (section.dataset.pgInit === '1') return;
    section.dataset.pgInit = '1';
    var $$ = function (sel) { return Array.prototype.slice.call(section.querySelectorAll(sel)); };

    /* ---- swatch click -> swap card image ---- */
    $$('[data-pg-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        var card = sw.closest('.pg__card');
        if (!card) return;
        var img = card.querySelector('.pg__img--primary');
        if (img && sw.dataset.img) { img.src = sw.dataset.img; img.removeAttribute('srcset'); }
        card.querySelectorAll('[data-pg-swatch]').forEach(function (x) { x.classList.remove('is-active'); });
        sw.classList.add('is-active');
      });
    });

    /* ---- wishlist ---- */
    $$('[data-pg-wish]').forEach(function (w) {
      w.addEventListener('click', function (e) {
        e.preventDefault();
        w.classList.toggle('is-active');
        w.textContent = w.classList.contains('is-active') ? '♥' : '♡';
      });
    });

    /* ---- quick add to cart ---- */
    $$('[data-pg-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.variantId;
        if (!id || btn.disabled) return;
        btn.classList.add('is-loading');
        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            btn.classList.remove('is-loading');
            if (!res.ok) { toast(res.d && res.d.description ? res.d.description : 'Could not add'); return; }
            refreshCartCount();
            toast('✓ Added to cart');
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
          })
          .catch(function () { btn.classList.remove('is-loading'); toast('Network error'); });
      });
    });

    /* ---- slider ---- */
    if (section.dataset.layout === 'slider') {
      var track = section.querySelector('[data-pg-track]');
      var prev = section.querySelector('[data-pg-prev]');
      var next = section.querySelector('[data-pg-next]');
      var dotsWrap = section.querySelector('[data-pg-dots]');
      if (track) {
        var cardW = function () {
          var card = track.querySelector('.pg__card');
          if (!card) return track.clientWidth;
          var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
          return card.getBoundingClientRect().width + gap;
        };
        var page = function () { return Math.max(1, Math.round(track.clientWidth / cardW())); };

        function updateArrows() {
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -cardW() * page(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: cardW() * page(), behavior: 'smooth' }); });

        // dots
        var dots = [];
        function buildDots() {
          if (!dotsWrap) return;
          dotsWrap.innerHTML = '';
          dots = [];
          var pages = Math.ceil(track.scrollWidth / track.clientWidth);
          for (var i = 0; i < pages; i++) {
            var d = document.createElement('button');
            d.className = 'pg__dot' + (i === 0 ? ' is-active' : '');
            d.type = 'button';
            (function (idx) { d.addEventListener('click', function () { track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' }); }); })(i);
            dotsWrap.appendChild(d);
            dots.push(d);
          }
        }
        function updateDots() {
          if (!dots.length) return;
          var active = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
        }
        buildDots();

        track.addEventListener('scroll', function () { updateArrows(); updateDots(); }, { passive: true });
        window.addEventListener('resize', function () { buildDots(); updateArrows(); });
        updateArrows();

        // autoplay
        if (section.dataset.autoplay === 'true') {
          var speed = (parseInt(section.dataset.speed, 10) || 4) * 1000;
          var timer = setInterval(function () {
            if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) {
              track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              track.scrollBy({ left: cardW() * page(), behavior: 'smooth' });
            }
          }, speed);
          section.addEventListener('mouseenter', function () { clearInterval(timer); });
        }
      }
    }
    /* ---- promo slider ---- */
    var promo = section.querySelector('[data-pg-promo]');
    if (promo) {
      var ptrack = promo.querySelector('[data-pg-promo-track]');
      var pdotsWrap = promo.querySelector('[data-pg-promo-dots]');
      var pslides = ptrack ? ptrack.querySelectorAll('.pg__promo-slide') : [];
      if (ptrack && pslides.length > 1) {
        var pdots = [];
        if (pdotsWrap) {
          for (var i = 0; i < pslides.length; i++) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'pg__dot' + (i === 0 ? ' is-active' : '');
            (function (idx) { b.addEventListener('click', function () { ptrack.scrollTo({ left: idx * ptrack.clientWidth, behavior: 'smooth' }); }); })(i);
            pdotsWrap.appendChild(b); pdots.push(b);
          }
        }
        ptrack.addEventListener('scroll', function () {
          var a = Math.round(ptrack.scrollLeft / ptrack.clientWidth);
          pdots.forEach(function (d, i) { d.classList.toggle('is-active', i === a); });
        }, { passive: true });
        if (promo.dataset.autoplay === 'true') {
          var pspeed = (parseInt(promo.dataset.speed, 10) || 4) * 1000;
          var ptimer = setInterval(function () {
            var a = Math.round(ptrack.scrollLeft / ptrack.clientWidth);
            var nextI = (a + 1) % pslides.length;
            ptrack.scrollTo({ left: nextI * ptrack.clientWidth, behavior: 'smooth' });
          }, pspeed);
          promo.addEventListener('mouseenter', function () { clearInterval(ptimer); });
        }
      }
    }
  }

  function boot() { document.querySelectorAll('.pg[data-section-id]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.pg[data-section-id]');
    if (el) { el.dataset.pgInit = ''; initSection(el); }
  });
})();
